import { checkDevtoolsEnabled, checkPrintToConsole } from './checkDevtoolsEnabled';
import { safe } from './safe';
export const createLogger = ({
  onLog,
  devtoolsEnabled = checkDevtoolsEnabled(),
  printToConsole = checkPrintToConsole(),
  logs = [],
  defaultTags = {}
}) => {
  const makeLog = level => (message, tags) => {
    safe(() => {
      const mergedTags = Object.assign({}, defaultTags, tags);
      const now = Date.now();
      if (devtoolsEnabled) {
        const log = {
          timestamp: now,
          message,
          level,
          tags: mergedTags
        };
        logs.push(log);
        onLog(log);
      }
      if (printToConsole) {
        const baseString = `${now} [${mergedTags.component || 'unknown'}] ${message}`;
        const entityInfoString = mergedTags !== null && mergedTags !== void 0 && mergedTags.instanceKey ? `| ${mergedTags.instanceKey}` : mergedTags !== null && mergedTags !== void 0 && mergedTags.typeName ? `| ${mergedTags.typeName}` : '';
        console[level](`${baseString} ${entityInfoString}`);
      }
    });
  };
  return {
    debug: makeLog('debug'),
    info: makeLog('info'),
    warn: makeLog('warn'),
    error: makeLog('error'),
    getLogs: () => logs,
    withTags: tags => createLogger({
      onLog,
      devtoolsEnabled,
      printToConsole,
      logs,
      defaultTags: Object.assign({}, defaultTags, tags)
    })
  };
};